import { ReactElement } from "react";

import ReactMarkdown from "react-markdown";

import {
  FormConfig,
  ContactConsentFieldConfig,
} from "@evergiving/common/dist/es2015/form";
import { ContactConsentKind } from "@evergiving/common/dist/es2015/pledge";

import { LabelledField } from "@/lib/components/LabelledField";
import { LabelText } from "@/lib/components/LabelText";
import { Checkbox } from "@/lib/components/Checkbox";

export function ContactConsentField({
  formConfig,
  contactConsentFieldConfig,
}: {
  formConfig: FormConfig;
  contactConsentFieldConfig: ContactConsentFieldConfig;
}): ReactElement | null {
  const fields = [];

  const { contactOptions, labelText } = contactConsentFieldConfig;

  if (formConfig.phoneNumber) {
    {
      const optionConfig = contactOptions[ContactConsentKind.Phone];
      if (optionConfig) {
        fields.push(
          <LabelledField id="contactPhone" key="phone">
            <Checkbox name="phoneContactChecked" />
            <LabelText>{optionConfig.optionText}</LabelText>
          </LabelledField>
        );
      }
    }

    {
      const optionConfig = contactOptions[ContactConsentKind.SMS];
      if (optionConfig) {
        fields.push(
          <LabelledField id="contactSMS" key="sms">
            <Checkbox name="smsContactChecked" />
            <LabelText>{optionConfig.optionText}</LabelText>
          </LabelledField>
        );
      }
    }

    {
      const optionConfig = contactOptions[ContactConsentKind.WhatsApp];
      if (optionConfig) {
        fields.push(
          <LabelledField id="contactWhatsApp" key="whatsapp">
            <Checkbox name="whatsappContactChecked" />
            <LabelText>{optionConfig.optionText}</LabelText>
          </LabelledField>
        );
      }
    }
  }

  if (formConfig.emailAddress) {
    const optionConfig = contactOptions[ContactConsentKind.Email];
    if (optionConfig) {
      fields.push(
        <LabelledField id="contactEmail" key="email">
          <Checkbox name="emailContactChecked" />
          <LabelText>{optionConfig.optionText}</LabelText>
        </LabelledField>
      );
    }
  }

  if (formConfig.address) {
    const optionConfig = contactOptions[ContactConsentKind.Post];
    if (optionConfig) {
      fields.push(
        <LabelledField id="contactPost" key="post">
          <Checkbox name="postContactChecked" />
          <LabelText>{optionConfig.optionText}</LabelText>
        </LabelledField>
      );
    }
  }

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      <LabelText>{labelText}</LabelText>
      <div className="contactPreferences">{fields}</div>
      {formConfig.contactConsent?.footerMarkdown ? (
        <ReactMarkdown>
          {formConfig.contactConsent.footerMarkdown}
        </ReactMarkdown>
      ) : null}
    </>
  );
}
